<template>
  <div v-if="loading == true" class="hb-user-profile-edit-page">
    <el-skeleton />
  </div>

  <div v-else class="hb-user-profile-edit-page">
    <el-alert title="" type="error">
      <template slot="title">
        以下信息用于网申资料录入和文书书写，请认真对待，红色*为必填；请参见HKUST填写指南
        <el-link type="primary" @click="()=>{
          previewUrl='https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/admin_file/E711692654582745.pdf';
          previewName='HKUST填写指南.pdf'
        }">
          点击预览
        </el-link>
      </template>
    </el-alert>
    <UserProfileHeader title="基本信息" :required="true"/>
    <el-form
      size="small"
      label-width="120px"
      :rules="rules"
      :model="profile.user_base"
      ref="ruleForm"
    >
      <el-descriptions class="margin-top" :column="2" border>
        <el-descriptions-item>
          <template slot="label">
            <span class="require-flag">*</span>中文 (姓)
          </template>
          <el-form-item prop="name" label-width="0">
            <el-input
              style="width: 200px"
              placeholder="与有效证件上一致"
              v-model="profile.user_base.cn_name_xing"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <span class="require-flag">*</span>中文 (名)
          </template>
          <el-form-item prop="" label-width="0">
            <el-input
              v-model="profile.user_base.cn_name_ming"
              style="width: 200px"
              placeholder="与有效证件上一致"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <span class="require-flag">*</span>拼音 (姓)
          </template>
          <el-form-item prop="name" label-width="0">
            <el-input
              style="width: 200px"
              placeholder="与有效证件上一致"
              v-model="profile.user_base.en_name_xing"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <span class="require-flag">*</span>拼音 (名)
          </template>
          <el-form-item prop="" label-width="0">
            <el-input
              v-model="profile.user_base.en_name_ming"
              style="width: 200px"
              placeholder="与有效证件上一致"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-descriptions-item>

<!--        <el-descriptions-item>-->
<!--          <template slot="label"> <span class="require-flag">*</span>姓名(中) </template>-->
<!--          <el-form-item prop="name" label-width="0">-->
<!--            <el-input-->
<!--              placeholder="请输入姓名"-->
<!--              v-model="profile.user_base.name"-->
<!--              clearable-->
<!--            >-->
<!--            </el-input>-->
<!--          </el-form-item>-->
<!--        </el-descriptions-item>-->
<!--        <el-descriptions-item>-->
<!--          <template slot="label">-->
<!--            <span class="require-flag">*</span>姓名(拼音)-->
<!--          </template>-->
<!--          <el-form-item prop="" label-width="0">-->
<!--            <el-input-->
<!--              v-model="profile.user_base.cname"-->
<!--              style="width: 200px"-->
<!--              placeholder="(姓-大写）（拼音）"-->
<!--              clearable-->
<!--            >-->
<!--            </el-input>-->
<!--          </el-form-item>-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item>
            <template slot="label">
              <span class="require-flag">*</span>电话号码
            </template>
            <el-form-item prop="" label-width="0">
              <el-input
              v-model="profile.user_base.phone"
                style="width: 220px"
                placeholder="请输入正在使用的有效电话"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><span class="require-flag">*</span> 性别 </template>
          <el-form-item prop="sex" label-width="0">
            <el-radio-group v-model="profile.user_base.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><span class="require-flag">*</span> 出生日期 </template>
          <el-form-item prop="birthday" label-width="0">
            <el-date-picker
              v-model="profile.user_base.birthday"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><span class="require-flag">*</span> 独生子女 </template>
          <el-form-item prop="child" label-width="0">
            <el-radio-group v-model="profile.user_base.child">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><span class="require-flag">*</span> 出生地 </template>
          <el-form-item prop="birthplace" label-width="0">
            <address_view
              :address_with="birthplace_with"
              :address_data="birthplace_arr"
              @choice_address="getBirthplace"
            ></address_view>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><span class="require-flag">*</span> 民族 </template>
          <el-form-item prop="nation" label-width="0">
            <el-select
              v-model="profile.user_base.nation"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in nation_list"
                :label="item"
                :value="item"
                :key="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><span class="require-flag">*</span> 种族 </template>
          <el-form-item prop="race" label-width="0">
            <el-select v-model="profile.user_base.race" placeholder="请选择">
              <el-option
                v-for="item in race_list"
                :label="item"
                :value="item"
                :key="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><span class="require-flag">*</span> 身份证号 </template>
          <el-form-item prop="id_card" label-width="0">
            <el-input
              placeholder="请输入身份证号"
              v-model="profile.user_base.id_card"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-descriptions-item>
        <!-- <el-descriptions-item>
          <template slot="label"
          ><span class="require-flag">*</span> 身份证上住址
          </template>
          <el-form-item prop="id_card_address" label-width="0">
            <el-input
              placeholder="请输入身份证上住址"
              v-model="profile.user_base.id_card_address"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-descriptions-item> -->


        <el-descriptions-item>
          <template slot="label"
          > <span class="require-flag">*</span>学位
          </template>
          <el-form-item prop="student_degree" label-width="0">
            <el-input
              placeholder="请输入学位"
              v-model="profile.user_base.student_degree"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <div><span class="require-flag">*</span>护照号码</div>
            <div>
              <el-link type="danger" @click="()=>{
                  previewUrl='https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/admin_file/E711692964234738.pdf';
                  previewName='护照办理流程.pdf'
                }">
                查看办理流程
              </el-link>
            </div>
          </template>
          <el-form-item prop="" label-width="0">
            <el-input   v-model="profile.user_base.passport_number" placeholder="请输入护照号码" clearable> </el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"
          > 护照起始日期
          </template>
          <el-form-item prop="" label-width="0">
            <el-date-picker
              v-model="profile.user_base.passport_start_time"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择护照起始日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"
          > 护照到期日期
          </template>
          <el-form-item prop="" label-width="0">
            <el-date-picker
              v-model="profile.user_base.passport_become_due_time"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择护照到期日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="1" border>
        <el-descriptions-item>
          <template slot="label"
          ><span class="require-flag">*</span> 家庭住址(中)
          </template>
          <el-form-item prop="" label-width="0">
            <el-input v-model="profile.user_base.home_Address_cn" placeholder="请输入家庭住址，需详细到门牌号" clearable>
            </el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"
          ><span class="require-flag">*</span> 家庭住址(英)
          </template>
          <el-form-item prop="" label-width="0">
            <el-input v-model="profile.user_base.home_Address_en" placeholder="请输入英文版家庭住址，需详细到门牌号" clearable>
            </el-input>
          </el-form-item>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="2" border>
        <el-descriptions-item>
          <template slot="label"
          ><span class="require-flag">*</span> 家庭住址邮编
          </template>
          <el-form-item prop="postal_code" label-width="0">
            <el-input
              placeholder="请输入家庭地址的邮政编码"
              v-model="profile.user_base.postal_code"
              clearable
              oninput="value=value.replace(/[^\d]/g,'')"
            >
            </el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"
          ><span class="require-flag">*</span> 现住址开始居住时间
          </template>
          <el-form-item prop="" label-width="0">
            <el-date-picker
              style="width: 300px"
              v-model="profile.user_base.live_time"

              value-format="yyyy-MM-dd"

            >
            </el-date-picker>

            <!-- <el-input   v-model="profile.user_base.live_time" placeholder="截止到入学前的时间；Yrs/months/days" clearable> </el-input> -->
          </el-form-item>
        </el-descriptions-item>
      </el-descriptions>
    </el-form>
<!--    <UserProfileHeader title="签证及国籍" :required="true"/>-->
<!--    <el-descriptions :column="3" border>-->
<!--      <el-descriptions-item>-->
<!--        <template slot="label"-->
<!--        ><span class="require-flag">*</span>-->
<!--          是否持有申请国家及其他国家的拒签史-->
<!--        </template>-->
<!--        <el-radio-group v-model="profile.visa.is_other">-->
<!--          <el-radio :label="1">否</el-radio>-->
<!--          <el-radio :label="2">是，若是</el-radio>-->
<!--        </el-radio-group>-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item>-->
<!--        <template slot="label"><span v-if="profile.visa.is_other == 2" class="require-flag"-->
<!--              >*</span-->
<!--            > 签证类型 </template>-->
<!--        <el-input v-model="profile.visa.visa_type" placeholder="请输入签证类型" clearable> </el-input>-->
<!--      </el-descriptions-item>-->
<!--    </el-descriptions>-->
<!--    <el-descriptions :column="3" border>-->
<!--      <el-descriptions-item>-->
<!--        <template slot="label"-->
<!--        ><span class="require-flag">*</span>-->
<!--          是否有过其他国家入境、旅游史-->
<!--        </template>-->
<!--        <el-radio-group v-model="profile.visa.is_travel_history">-->
<!--          <el-radio :label="1">否</el-radio>-->
<!--          <el-radio :label="2">是，若是</el-radio>-->
<!--        </el-radio-group>-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item>-->
<!--        <template slot="label"><span class="require-flag" v-if="profile.visa.is_travel_history == 2">*</span> 国家 </template>-->
<!--        <el-input  v-model="profile.visa.country" placeholder="请输入入境国家" clearable> </el-input>-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item>-->
<!--        <template slot="label"> 入境及出境日期 </template>-->
<!--        <el-input v-model="profile.visa.time" placeholder="查询护照页或移民局小程序" clearable>-->
<!--        </el-input>-->
<!--      </el-descriptions-item>-->
<!--    </el-descriptions>-->
<!--    <el-descriptions :column="3" border>-->
<!--      <el-descriptions-item>-->
<!--        <template slot="label"-->
<!--        ><span class="require-flag">*</span>-->
<!--          是否持有其他国家(地区)国籍(身份)-->
<!--        </template>-->
<!--        <el-radio-group v-model="profile.visa.is_other_identity" >-->
<!--          <el-radio :label="1">否</el-radio>-->
<!--          <el-radio :label="2">是，若是</el-radio>-->
<!--        </el-radio-group>-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item>-->
<!--        <template slot="label"><span class="require-flag" v-if="profile.visa.is_other_identity==2">*</span> 国家(地区) </template>-->
<!--        <el-input v-model="profile.visa.other_identity_country" placeholder="请输入持有国籍的国家" clearable> </el-input>-->
<!--      </el-descriptions-item>-->
<!--    </el-descriptions>-->

    <UserProfileHeader
      title="紧急联系人"
      :required="true"
      desc="1、必须是直系亲属，一般就填写父母信息，至少提供一方信息；2、如果是兄弟姐妹，必须年满18岁以上；3、必须填写至少一位紧急联系人"
    />
    <!-- <el-descriptions :column="1" border>

    </el-descriptions> -->
    <el-table :data="profile.emergency_contact.content">
      <el-table-column label="与申请人关系" width="120">
        <template slot-scope="scope">
          <div>
            <span class="require-flag" v-if="scope.row.relation == '父亲(生父)'"
                >*</span>
            {{ scope.row.relation }}
            </div>
        </template>
      </el-table-column>
      <el-table-column label="姓名" width="120">
        <template slot-scope="scope">
          <div>
            <el-input v-model="scope.row.name" placeholder="必填"></el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="出生日期（年/月/日）" width="180">
        <template slot-scope="scope">
          <div>
            <el-input v-model="scope.row.birthday" placeholder="必填"></el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="联系电话/手机" width="200">
        <template slot-scope="scope">
          <div>
            <el-input v-model="scope.row.phone" placeholder="必填"></el-input>
          </div>
        </template>
        ></el-table-column>
        <el-table-column label="工作类别" width="200">
          <template slot-scope="scope">
            <!-- <div>
              <el-input v-if="globalVariable == 'show'"v-model="scope.row.work_type" placeholder="必填"></el-input>
              <el-input v-if="globalVariable == 'hide'" v-model="scope.row.work_type" show-password placeholder="必填"></el-input>
            </div> -->
            <el-autocomplete
      class="inline-input"
      v-model="scope.row.work_type"
      :fetch-suggestions="querySearch"
      placeholder="请输入工作类别"
      @select="handleSelect"
    ></el-autocomplete>
          </template>
          ></el-table-column
        >
      <el-table-column>
        <template #header>
          <span class="require-flag">*</span>
          <span>工作单位</span>
        </template>
        <template slot-scope="scope">
          <div>
            <el-input
              v-model="scope.row.work_unit"
              placeholder="请填写工作单位"
            ></el-input>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="地址">
        <template slot-scope="scope">
          <div>
            <el-input v-model="scope.row.email" placeholder="必填"></el-input>
          </div>
        </template>
      </el-table-column> -->
<!--      <el-table-column label="地址">-->
<!--        <template slot-scope="scope">-->
<!--          <div>-->
<!--            <el-input v-model="scope.row.address" placeholder="必填"></el-input>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <UserProfileHeader title="标化成绩" />
    <el-descriptions
      class="margin-top"
      :column="1"
      border
      style="margin: 15px 0"
    >
      <!-- <el-descriptions-item>
        <template slot="label"
        >
          语言成绩是否合格
        </template>
        <el-radio-group v-model="profile.language_achievement_and_account_secrecy.is_qualified">
          <el-radio :label="6">成绩合格</el-radio>
          <el-radio :label="7">成绩不合格</el-radio>
        </el-radio-group>

      </el-descriptions-item> -->
      <el-descriptions-item
        :labelStyle="secondlabel"
        v-for="(item, i) in profile.language_achievement_and_account_secrecy
            .content"
      >
        <template slot="label">类型</template>
        <div style="float: left; width: 10%">
          <el-select v-model="item.type" placeholder="请选择">
            <el-option
              v-for="ite in language_achievement_and_account_secrecy_list"
              :label="ite"
              :value="ite"
            >
            </el-option>
          </el-select>
        </div>
        <el-input
          v-if="item.type == 'IELTS' || item.type == 'TOEFL'"
          placeholder="考试时间(年/月/日)"
          v-model="item.exam_time"
          clearable
          style="float: left; width: 15%; margin: 0 5px"
        />
        <el-input
          :placeholder="
              item.type == 'IELTS' || item.type == 'TOEFL'
                ? '总分(听力/阅读/口语/写作)'
                : '总分'
            "
          v-model="item.fraction"
          clearable
          style="float: left; width: 15%; margin: 0 5px"
        />
        <el-input
          v-if="item.type == 'IELTS' || item.type == 'TOEFL'|| item.type == 'GRE' || item.type == 'GMAT'"
          placeholder="输入UserName"
          clearable
          v-model="item.username"
          style="float: left; width: 15%; margin: 0 5px"
        />
        <el-input
          v-if="item.type == 'IELTS' || item.type == 'TOEFL'|| item.type == 'GRE' || item.type == 'GMAT'"
          placeholder="输入Password"
          clearable
          v-model="item.password"
          style="float: left; width: 15%; margin: 0 5px"
        />
<!--        <el-input-->
<!--          v-if="item.type == 'IELTS' || item.type == 'TOEFL'"-->
<!--          placeholder="预计下次考试(年/月/日)"-->
<!--          clearable-->
<!--          v-model="item.next_exam_time"-->
<!--          style="float: left; width: 20%; margin: 0 5px"-->
<!--        />-->
        <el-popconfirm
          title="是否确认删除？"
          @confirm="delLanguageAchievementAndAccountSecrecyList(i)"
        >
          <el-button
            slot="reference"
            icon="el-icon-delete"
            circle
          ></el-button>
        </el-popconfirm>
      </el-descriptions-item>
    </el-descriptions>
    <div style="text-align: left">
      <el-button plain @click="addLanguageAchievementAndAccountSecrecyList"
      >增加</el-button
      >
    </div>
    <UserProfileHeader title="教育经历" :desc="eduDesc" :required="true"/>
    <el-card
      class="box-card"
      style="width: 100%"
      v-for="(item, index) in profile.educational_background"
    >
      <el-popconfirm
        title="是否确认删除？"
        @confirm="delEducationalBackground(index)"
      >
        <el-link slot="reference" type="primary" style="margin-bottom: 10px"
        >删除</el-link
        >
      </el-popconfirm>

      <el-descriptions class="margin-top" :column="2" border>
        <el-descriptions-item>
          <template slot="label"><span class="require-flag">*</span> 学校(中) </template>
          <el-input placeholder="请输入" v-model="item.school" clearable>
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"
          ><span class="require-flag">*</span> 学校(英)
          </template>
          <el-input placeholder="学校英文必须与成绩单上一致" v-model="item.school_ename" clearable>
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><span class="require-flag">*</span> 专业(中) </template>
          <el-input placeholder="请输入" v-model="item.major" clearable>
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"
          ><span class="require-flag">*</span> 专业(英)
          </template>
          <el-input placeholder="专业英文必须与成绩单上一致" v-model="item.major_ename" clearable>
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><span class="require-flag">*</span> 在读状态 </template>
          <el-radio-group v-model="item.reading_status">
            <el-radio :label="0">已毕业</el-radio>
            <el-radio :label="1">在读</el-radio>
          </el-radio-group>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><span class="require-flag">*</span> 学历 </template>
          <el-select v-model="item.stage" filterable placeholder="请选择">
            <el-option
              v-for="item in stage_list"
              :label="item"
              :value="item"
              :key="item"
            ></el-option>
          </el-select>
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label"><span class="require-flag">*</span> 类型 </template>
          <el-select v-model="item.degree_type" filterable placeholder="请选择">
            <el-option
              v-for="item in degree_type_list"
              :label="item"
              :value="item"
              :key="item"
            ></el-option>
            <el-option label="夏校/交换" value="夏校/交换" key="夏校/交换" v-if="!profile.exchange_experiences.length"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><span class="require-flag">*</span>时间(入学-毕业)</template>
          <el-date-picker
            v-model="item.time"
            type="monthrange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 年级排名 </template>
          <el-input placeholder="请输入" v-model="item.ranking" clearable>
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> <span class="require-flag">*</span>GPA/满GPA/均分 </template>
          <el-input
            placeholder="请输入GPA"
            v-model="item.gpa"
            clearable
            style="width: 120px; margin-right: 10px"
          ></el-input>
          <el-input
            placeholder="满GPA多少?"
            v-model="item.all_gpa"
            clearable
            style="width: 130px; margin-right: 10px"
          ></el-input>
          <el-input
            placeholder="请输入均分"
            v-model="item.sharing"
            clearable
            style="width: 120px"
          ></el-input>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions class="margin-top" :column="1" border>
        <el-descriptions-item>
          <template slot="label"> 是否转专业 </template>
          <el-input placeholder="是的话排第几，由什么专业转什么专业" v-model="item.is_change_major" clearable>
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 核心课程 </template>
          <el-input placeholder="英文（跟成绩单专业名一样）+分数" v-model="item.core_curriculum" clearable>
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 备注 </template>
          <el-input  type="textarea" :rows="2"  placeholder="学校有无特殊领域排名靠前，例如财经、法律、创新等领域排名（对文书老师有帮助）" v-model="item.remarks" clearable>
          </el-input>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions
        class="margin-top"
        :column="1"
        border
        style="margin-bottom: 15px"
      >
        <el-descriptions-item :labelStyle="secondlabel" label="培养计划">
          <elevenUpdate :fileList="item.fileList" :item="item" @url_data="getUrl" />
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <div style="text-align: left">
      <el-button plain @click="addEducationalBackground">增加</el-button>
    </div>

    <div v-if="profile.exchange_experiences.length">
      <UserProfileHeader title="夏校/交换经历"/>
      <el-card
        class="box-card"
        style="width: 100%"
        v-for="(item, index) in profile.exchange_experiences"
      >
        <el-popconfirm
          title="是否确认删除？"
          @confirm="delExchangeExperiences(index)"
        >
          <el-link
            slot="reference"
            type="primary"
            style="margin-bottom: 10px"
            data-html2canvas-ignore="true"
          >删除</el-link
          >
        </el-popconfirm>
        <el-descriptions class="margin-top" :column="2" border>
          <el-descriptions-item>
            <template slot="label"
            ><span class="require-flag">*</span> 学校(中)
            </template>
            <el-input placeholder="请输入" v-model="item.school" clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"
            ><span class="require-flag">*</span> 学校(英)
            </template>
            <el-input placeholder="学校英文必须与成绩单上一致" v-model="item.school_en" clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"
            ><span class="require-flag">*</span> 专业(中)
            </template>
            <el-input placeholder="请输入" v-model="item.major" clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"
            ><span class="require-flag">*</span> 专业(英)
            </template>
            <el-input placeholder="专业英文必须与成绩单上一致" v-model="item.major_en" clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"
            ><span style="color: red">*</span> 类型
            </template>
            <el-select v-model="item.type" filterable placeholder="请选择">
              <el-option
                v-for="item in exchange_experiences_type_list"
                :label="item"
                :value="item"
                :key="item"
              ></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"
            ><span style="color: red">*</span>时间</template
            >
            <el-date-picker
              style="width: 300px"
              v-model="item.time"
              type="monthrange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> GPA/均分 </template>
            <el-input
              placeholder="请输入GPA"
              v-model="item.gpa"
              clearable
              style="width: 120px; margin-right: 20px"
            ></el-input>
            <el-input
              placeholder="请输入均分"
              v-model="item.sharing"
              clearable
              style="width: 120px"
            ></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </el-card>
      <div style="text-align: left" data-html2canvas-ignore="true">
        <el-button plain @click="addExchangeExperiences">增加</el-button>
      </div>
    </div>


    <UserProfileHeader title="问卷"  />
    <el-card
      class="box-card"
      style="width: 100%"
    >
      <el-form label-position="top" ref="form" :model="questionnaire" >
        <el-form-item label="1、你日常通过哪些平台了解留学资讯?(可多选)">
          <el-checkbox-group v-model="questionnaire.type_1">
            <div><el-checkbox label="小红书" name="type"></el-checkbox></div>
            <div><el-checkbox label="B站" name="type"></el-checkbox></div>
            <div><el-checkbox label="抖音" name="type"></el-checkbox></div>
            <div><el-checkbox label="微博" name="type"></el-checkbox></div>
            <div><el-checkbox label="知乎" name="type"></el-checkbox></div>
            <div><el-checkbox label="其他" name="type"></el-checkbox></div>
          </el-checkbox-group>
          <div style="display: flex">
            <span style="color: red;margin-right: 10px" v-if="checkCheckBoxAA(questionnaire.type_1)">*</span>
            <el-input
              style="float: left"
              type="textarea"
              v-model="questionnaire.type_1_other"
              v-if="checkCheckBoxAA(questionnaire.type_1)"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="2、你了解留学资讯的时候通过哪些方式选中介?(可多选)">
          <el-checkbox-group v-model="questionnaire.type_2">
            <div><el-checkbox label="别人安利/推荐" name="type"></el-checkbox></div>
            <div><el-checkbox label="社交平台发帖/发信息主动寻找" name="type"></el-checkbox></div>
            <div><el-checkbox label="浏览留学干货笔记" name="type"></el-checkbox></div>
            <div><el-checkbox label="看视频收集信息" name="type"></el-checkbox></div>
            <div><el-checkbox label="其他" name="type"></el-checkbox></div>
          </el-checkbox-group>
          <div style="display: flex">
            <span style="color: red;margin-right: 10px" v-if="checkCheckBoxAA(questionnaire.type_2)">*</span>
            <el-input
              style="float: left"
              type="textarea"
              v-model="questionnaire.type_2_other"
              v-if="checkCheckBoxAA(questionnaire.type_2)"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="3、你选择跟嗡嗡合作主要源于以下哪些原因?(可多选)">
          <el-checkbox-group v-model="questionnaire.type_3">
            <div><el-checkbox label="别人安利/推荐" name="type"></el-checkbox></div>
            <div><el-checkbox label="咨询老师的沟通很舒服" name="type"></el-checkbox></div>
            <div><el-checkbox label="规划老师比较专业" name="type"></el-checkbox></div>
            <div><el-checkbox label="系统安全可监管全流程服务" name="type"></el-checkbox></div>
            <div><el-checkbox label="其他" name="type"></el-checkbox></div>
          </el-checkbox-group>
          <div style="display: flex">
            <span style="color: red;margin-right: 10px" v-if="checkCheckBoxAA(questionnaire.type_3)">*</span>
            <el-input
              style="float: left"
              type="textarea"
              v-model="questionnaire.type_3_other"
              v-if="checkCheckBoxAA(questionnaire.type_3)"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="4、什么时候你愿意把嗡嗡推荐给其他人?(可多选）">
          <el-checkbox-group v-model="questionnaire.type_4">
            <div><el-checkbox label="我日常体验好的时候" name="type"></el-checkbox></div>
            <div><el-checkbox label="我拿到offer的时候" name="type"></el-checkbox></div>
            <div><el-checkbox label="别人向我了解中介的时候" name="type"></el-checkbox></div>
            <div><el-checkbox label="给我提供额外价值的时候" name="type"></el-checkbox></div>
            <div><el-checkbox label="其他" name="type"></el-checkbox></div>
          </el-checkbox-group>
          <div style="display: flex">
            <span style="color: red;margin-right: 10px" v-if="checkCheckBoxAA(questionnaire.type_4)">*</span>
            <el-input
              style="float: left"
              type="textarea"
              v-model="questionnaire.type_4_other"
              v-if="checkCheckBoxAA(questionnaire.type_4)"
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
    </el-card>


    <HBFixedButton
      @click="submitProfile"
      v-loading.fullscreen.lock="from_loading"
      :desc="infoStatusDesc(study_abroad_information_status)"
    />
    <HBFilePreview :previewUrl="previewUrl" :fileName="previewName" @updateVisible="previewUrl=null;previewName=null"/>

  </div>
</template>
<script>
import address_view from "./address_view.vue";
import UserProfileHeader from "./userprofile_header.vue";
import { getQuestionnaire, profile_list, profile_update } from "@/api/mycenter_studyabroad";
import HBRadioGroupDialog from "../HBCommon/HBRadioGroupDialog/HBRadioGroupDialog";
import HBFixedButton from "../HBCommon/HBFixedButton/HBFixedButton";
import { infoStatusDesc } from "../HBCommon/util";
import HBFilePreview from '@/components/HBCommon/HBFilePreview/HBFilePreview';
import elevenUpdate from "./tab_eleven_update.vue";
import {
  academic_projects_placeholder,
  work_experience_placeholder,
} from "../HBCommon/placeholder";
import { kCacheAbroadInfos } from "../tool";
export default {
  name: "TabThree",
  props: ["flag"],
  components: {
    elevenUpdate,
    HBFilePreview,
    address_view,
    UserProfileHeader,
    HBRadioGroupDialog,
    HBFixedButton,
  },
  data() {
    return {
      questionnaire: {
        type_1: [],
        type_1_other: '',
        type_2: [],
        type_2_other: '',
        type_3: [],
        type_3_other: '',
        type_4: [],
        type_4_other: ''
      },
      previewUrl: null,
      previewName: null,
      defaultProfileData: [],
      radioGroupDialogFlag: false,
      radioGroupDialogDatasource: [],
      from_loading: false,
      DialogSon: false,
      loading: true,
      user_bind_info: {},
      birthplace_arr: "",
      home_address_arr: "",
      home_address_with: "width: 45%",
      rowCenter: { "text-align": "center" },
      birthplace_with: "width: 100%",
      secondlabel: {
        width: "120px",
        "text-align": "center",
      },
      secondCont: {
        width: "42%",
      },
      secondContTwo: {
        width: "240px",
        "text-align": "center",
      },
      sex: [
        { text: "男", value: "1" },
        { text: "女", value: "2" },
      ],
      child: [
        { text: "是", value: "1" },
        { text: "不是", value: "2" },
      ],
      education_level_list: ["初中", "高中", "大学", "其他"], // 学历
      nation_list: [
        "汉族",
        "蒙古族",
        "藏族",
        "苗族",
        "壮族",
        "回族",
        "维吾尔族",
        "彝族",
        "布依族",
        "朝鲜族",
        "侗族",
        "白族",
        "哈尼族",
        "傣族",
        "傈僳族",
        "畲族",
        "拉祜族",
        "满族",
        "瑶族",
        "土家族",
        "哈萨克族",
        "黎族",
        "佤族",
        "高山族",
        "水族",
        "东乡族",
        "景颇族",
        "土族",
        "仫佬族",
        "布朗族",
        "毛南族",
        "锡伯族",
        "普米族",
        "纳西族",
        "柯尔克孜族",
        "达斡尔族",
        "羌族",
        "撒拉族",
        "仡佬族",
        "阿昌族",
        "塔吉克族",
        "怒族",
        "俄罗斯族",
        "德昂族",
        "裕固族",
        "塔塔尔族",
        "鄂伦春族",
        "门巴族",
        "基诺族",
        "乌孜别克族",
        "鄂温克族",
        "保安族",
        "京族",
        "独龙族",
        "赫哲族",
        "珞巴族",
      ],
      // 种族
      race_list: [
        "Chinese",
        "Arab",
        "Asian or Asian British-Bangladeshi",
        "Asian or Asian British-Indian",
        "Asian or Asian British- Pakistani",
        "Black or Black British-African",
        "Black or Black British-Caribbean",
        "Gypsy or Traveller",
        "Information Refused",
        "Mixed-White and Asian",
        "Mixed-White and Black African",
        "Mixed-White and Black Caribbean",
        "Not Known",
        "Other Asian Background",
        "Other Black Background",
        "Other Ethnic Background",
        "Other Mixed Background",
        "White",
      ],
      language_achievement_and_account_secrecy_list: [
        "IELTS",
        "TOEFL",
        "GRE",
        "GMAT",
        "Duolingo",
        "朗思",
        "全国普通话水平测试",
        "CET6",
        "IB",
        "A-LEVEL",
        "SAT",
        "ACT",
        "VCE",
      ],
      inputVisible: false,
      inputValue: "",
      // 荣誉奖励类型
      honorary_rewards_list: ["奖学金", "竞赛", "义工", "其他"],
      // 婚姻状况
      marriage_list: ["原配", "离异", "再婚", "丧偶"],
      // 阶段
      stage_list: ["本科", "硕士", "高中", "专科", "博士", "中专"],
      // 学位类型
      degree_type_list: ["第一学位", "第二学位", "辅修学位", "双学位"],
      // 类型
      exchange_experiences_type_list: ["夏校", "交换"],
      // 项目类型
      academic_projects_list: ["论文", "比赛", "课程"],
      // 工作类型
      work_experience_list: ["兼职", "全职"],
      // 验证规则
      rules: {},
      study_abroad_information_status: 0,
      // 个人信息
      profile: {
        // 紧急联系人
        emergency_contact: {
          user_information_id: "",
          content: [
            {
              relation: "父亲(生父)",
              name: null,
              birthday: null,
              phone: null,
              work_unit: null,
              work_type:'',
              // email: null,
              // address: null,
            },
            {
              relation: "母亲(生母)",
              name: null,
              birthday: null,
              phone: null,
              work_unit: null,
              work_type:'',
              // email: null,
              // address: null,
            },
            {
              relation: "兄弟姐妹",
              name: null,
              birthday: null,
              phone: null,
              work_unit: null,
              work_type:'',
              // email: null,
              // address: null,
            },
          ],
        },
        // 基本信息
        user_base: {
          user_information_id: "",
          race: "", // 种族
          cn_name_xing: '', //中文 (姓)
          cn_name_ming: '', //中文 (名)
          en_name_xing: '', //英文 (姓)
          en_name_ming: '', //英文 (名)
          name: "", // 姓名
          cname: "", // 姓名
          sex: "", //  性别
          birthday: "", // 出生日期
          birthplace: "", // 出生地
          child: "", // 是否是独生子女
          nation: "", // 民族
          postal_code: "", // 邮政编码
          id_card: "", // 身份证
          id_card_address:'',// 身份证上住址
          passport_number: "", // 护照号码
          student_degree: '',
          passport_start_time: "", // 护照起始日期
          passport_become_due_time: "", // 护照到期日期
          home_Address_cn: "", // 家庭住址(中)
          home_Address_en: "", // 家庭住址(英)
          live_time: "", // 居住时长
          phone:""
        },
        // visa: {
        //   is_other: "", //是否持有申请国家及其他国家的拒签史
        //   visa_type: "", //签证类型
        //   is_travel_history: "", //是否有过其他国家入境、旅游史
        //   travel_history_country: "", //入境国家
        //   time: "", //入境及出境日期
        //   is_other_identity: "", //是否持有其他国家(地区)国籍(身份)
        //   other_identity_country: "", //请输入持有国籍的国家
        // },
        // 自我评价
        user_evaluate: {
          user_information_id: "",
          dynamicTags: [],
          appraise: "",
        },
        // 标化成绩
        language_achievement_and_account_secrecy: {
          user_information_id: "",
          is_qualified:'',
          content: [],
        },
        // 教育经历
        educational_background: [],
        // 夏校/交换经历
        exchange_experiences: [],
        // 学术/项目
        academic_projects: [],
        // 工作经历
        work_experience: [],
        // 荣誉奖励
        honorary_rewards: [],
        // 论文
        thesis: [],
        // 课外活动
        extracurricular_activities: [],
        user_id: "",
        study_abroad_information_status: 0,
      },
    };
  },
  created() {
    this.$bus.on("abroad_tabs_changes", (newVal) => {
      if (newVal == this.flag) {
        this.studentProfile();
      }
    });
    this.studentProfile();
    this.getQuestionnaire();
  },
  methods: {
    querySearch(queryString, cb) {
        // 调用 callback 返回建议列表的数据
        cb([{ text: '政府机关', value: '政府机关' }, { text: '事业单位', value: '事业单位' }, { text: '国有企业', value: '国有企业' }, { text: '外资企业', value: '外资企业' }, { text: '私营企业', value: '私营企业' }, { text: '合资企业', value: '合资企业' },{ text: '高校', value: '高校' }]);
      },
    getUrl(val){
    },
    validatorIdCard(value) {
      // 地区
      var aCity = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外",
      };
      // 验证长度
      if (!/^\d{17}(\d|x)$/i.test(value)) {
        // callback(
        //   new Error("您输入的身份证号长度或格式错误，请输入正确的身份证号")
        // );
        return new Error(
          "您输入的身份证号长度或格式错误，请输入正确的身份证号"
        );
      }
      // 验证前两位是否为省份代码
      value = value.replace(/x$/i, "a");
      if (aCity[parseInt(value.substr(0, 2))] == null) {
        // callback(
        //   new Error("您输入的身份证号长度或格式错误，请输入正确的身份证号")
        // );
        return new Error(
          "您输入的身份证号长度或格式错误，请输入正确的身份证号"
        );
      }
      // 身份证上的出生年月校验
      var sBirthday =
        value.substr(6, 4) +
        "-" +
        Number(value.substr(10, 2)) +
        "-" +
        Number(value.substr(12, 2));
      var d = new Date(sBirthday.replace(/-/g, "/"));
      if (
        sBirthday !=
        d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
      ) {
        // callback(new Error("您输入的身份证号不合法，请输入正确的身份证号"));
        return new Error("您输入的身份证号不合法，请输入正确的身份证号");
      }
      // 身份证校验位判断
      var iSum = 0;
      for (var i = 17; i >= 0; i--) {
        iSum += (Math.pow(2, i) % 11) * parseInt(value.charAt(17 - i), 11);
      }
      if (iSum % 11 != 1) {
        // callback(new Error("您输入的身份证号不合法，请输入正确的身份证号"));

        return new Error("您输入的身份证号不合法，请输入正确的身份证号");
      }
      // callback();
      return null;
    },
    infoStatusDesc(type) {
      return infoStatusDesc(type);
    },
    work_experience_placeholder() {
      return work_experience_placeholder();
    },
    academic_projects_placeholder(type) {
      return academic_projects_placeholder(type);
    },
    addDynamicTags() {
      this.DialogSon = true;
    },
    onSubmit() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.profile.user_evaluate.dynamicTags.push(inputValue);
      } else {
        this.$message.error("请填写数据");
        return;
      }
      this.DialogSon = false;
      this.inputValue = "";
    },
    checkCheckBoxAA(_type) {
      if (
        _type &&
        _type.indexOf('其他') === -1
      ) {
        return false
      } else {
        return true
      }
    },

    submitProfile() {
      this.$confirm("是否确认保存？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submitData(3);
        })
        .catch(() => {});
    },
    submitData(val) {
      // if (
      //   this.profile &&
      //   this.profile.user_base &&
      //   this.profile.user_base.id_card
      // ) {
      //   const errror = this.validatorIdCard(this.profile.user_base.id_card);
      //   if (errror) {
      //     this.$message({ message: errror.message, type: "error" });
      //     return;
      //   }
      // }
      if (
        (this.questionnaire.type_1.indexOf('其他') !== -1 && !this.questionnaire.type_1_other) ||
        (this.questionnaire.type_2.indexOf('其他') !== -1 && !this.questionnaire.type_2_other) ||
        (this.questionnaire.type_3.indexOf('其他') !== -1 && !this.questionnaire.type_3_other) ||
        (this.questionnaire.type_4.indexOf('其他') !== -1 && !this.questionnaire.type_4_other)
      ){
        this.$message.error('请完善问卷其他内容')
        return
      }
      if (
        this.profile.language_achievement_and_account_secrecy.content.findIndex(
          (item) => !item.type
        ) >= 0
      ) {
        this.$message({ message: "请完善标化成绩", type: "error" });
        return;
      }
      let is_return = 0
      this.profile.emergency_contact.content.forEach((item, index) => {
        if ((item.name || item.phone || item.birthday) && !item.work_unit) {
          is_return = 1
        }
      })
      if (is_return) {
        this.$message.error('请完善紧急联系人工作单位')
        return
      }
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          var rdata = {};
          rdata.type = "pl";
          rdata.user_id = this.$route.query.userId;
          rdata.study_abroad_information_status = val;
          rdata.user_base = this.profile.user_base;
          // rdata.visa = this.profile.visa;
          rdata.emergency_contact = this.profile.emergency_contact;
          rdata.language_achievement_and_account_secrecy =
            this.profile.language_achievement_and_account_secrecy;
          rdata.educational_background = this.profile.educational_background;
          rdata.exchange_experiences = this.profile.exchange_experiences;
          rdata.questionnaire = this.questionnaire
          this.from_loading = true;
          kCacheAbroadInfos(JSON.stringify(rdata))
          profile_update(rdata)
            .then((response) => {
              this.from_loading = false;
              if (response.code === 200) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.$bus.emit("abroad-userprofile-updated");
                this.getQuestionnaire();
                this.studentProfile();
              }
            })
            .catch((error) => {
              this.from_loading = false;
              this.$message({message:error.message,type:'error'})
            });
        }
      });
    },
    checkMaterialsUploaded(id, next, specialClassName) {
      // 是否上传过材料
      var flag = false;
      if (this.defaultProfileData && this.defaultProfileData.length > 0) {
        if (specialClassName == "language_achievement_and_account_secrecy") {
          const specialClassObj = this.defaultProfileData.find(
            (obj) => obj.class == specialClassName
          );
          if (specialClassObj && specialClassObj.info) {
            // const conList = JSON.parse(specialClassObj.con).content || [];
            const index = specialClassObj.info.findIndex(
              (obj) => obj.id == id && obj.upload && obj.upload.length > 0
            );

            flag = index >= 0;
          }
        } else {
          var re = this.defaultProfileData.find((item) => item.id == id);
          if (re && re.info) {
            const index = re.info.findIndex(
              (d) => d.upload && d.upload.length > 0
            );
            flag = index >= 0;
          }
        }
      }
      if (flag) {
        this.$confirm(
          "当前模块已上传过申请材料，删除后将会移除对应的申请材料，是否继续？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            next();
          })
          .catch((e) => {});
      } else {
        next();
      }
    },
    getQuestionnaire() {
      getQuestionnaire({ user_id: this.$route.query.userId }).then((response) => {
        if (response.data) {
          this.questionnaire = response.data
        }
      })
    },
    studentProfile() {
      profile_list({ user_id: this.$route.query.userId })
        .then((response) => {
          this.loading = false;
          this.defaultProfileData = response.data || [];
          var profile = this.profile;
          var home = [];
          profile.language_achievement_and_account_secrecy.content = [];
          profile.language_achievement_and_account_secrecy.is_qualified = '';
          profile.language_achievement_and_account_secrecy.user_information_id =
            "";
          profile.emergency_contact.user_information_id = "";
          profile.educational_background = [];
          profile.exchange_experiences = [];
          profile.academic_projects = [];
          profile.work_experience = [];
          profile.honorary_rewards = [];
          profile.thesis = [];
          profile.extracurricular_activities = [];
          // 获取个人绑定信息文稿状态
          if (
            response.data.length &&
            response.data[0].study_abroad_information_status
          ) {
            this.study_abroad_information_status =
              response.data[0].study_abroad_information_status.status;
          }
          response.data.forEach(function (item, index) {
            var content;
            content = JSON.parse(item.con);
            if (item.class === "other") {
              return;
            }
            if (item.class === "user_base") {
              if (content) {
                profile.user_base.user_information_id = item.id;
                if (content.race) {
                  profile.user_base.race = content.race;
                } else {
                  profile.user_base.race = "";
                }
                if (content.name) {
                  profile.user_base.name = content.name;
                } else {
                  profile.user_base.name = "";
                }
                if (content.cname) {
                  profile.user_base.cname = content.cname;
                } else {
                  profile.user_base.cname = "";
                }
                if (content.cn_name_xing) {
                  profile.user_base.cn_name_xing = content.cn_name_xing;
                } else {
                  profile.user_base.cn_name_xing = "";
                }
                if (content.cn_name_ming) {
                  profile.user_base.cn_name_ming = content.cn_name_ming;
                } else {
                  profile.user_base.cn_name_ming = "";
                }
                if (content.en_name_xing) {
                  profile.user_base.en_name_xing = content.en_name_xing;
                } else {
                  profile.user_base.en_name_xing = "";
                }
                if (content.en_name_ming) {
                  profile.user_base.en_name_ming = content.en_name_ming;
                } else {
                  profile.user_base.en_name_ming = "";
                }

                if (content.phone) {
                  profile.user_base.phone = content.phone;
                } else {
                  profile.user_base.phone = ''
                }
                if (content.sex) {
                  profile.user_base.sex = content.sex;
                } else {
                  profile.user_base.sex = "";
                }
                if (content.birthday) {
                  profile.user_base.birthday = content.birthday;
                } else {
                  profile.user_base.birthday = "";
                }
                if (content.birthplace) {
                  profile.user_base.birthplace = content.birthplace;
                } else {
                  profile.user_base.birthplace = "";
                }
                if (content.child) {
                  profile.user_base.child = content.child;
                } else {
                  profile.user_base.child = "";
                }
                if (content.nation) {
                  profile.user_base.nation = content.nation;
                } else {
                  profile.user_base.nation = "";
                }
                if (content.postal_code) {
                  profile.user_base.postal_code = content.postal_code;
                } else {
                  profile.user_base.postal_code = "";
                }
                if (content.id_card) {
                  profile.user_base.id_card = content.id_card;
                } else {
                  profile.user_base.id_card = "";
                }
                if (content.id_card_address) {
                  profile.user_base.id_card_address = content.id_card_address;
                } else {
                  profile.user_base.id_card_address = "";
                }
                if (content.birthplace) {
                  home = JSON.parse(content.birthplace).birthplace_code;
                } else {
                  home = [];
                }
                if (content.passport_number) {
                  profile.user_base.passport_number = content.passport_number;
                } else {
                  profile.user_base.passport_number = "";
                }
                if (content.student_degree) {
                  profile.user_base.student_degree = content.student_degree;
                } else {
                  profile.user_base.student_degree = "";
                }

                if (content.passport_start_time) {
                  profile.user_base.passport_start_time =
                    content.passport_start_time;
                } else {
                  profile.user_base.passport_start_time = "";
                }
                if (content.passport_become_due_time) {
                  profile.user_base.passport_become_due_time =
                    content.passport_become_due_time;
                } else {
                  profile.user_base.passport_become_due_time = "";
                }
                if (content.home_Address_cn) {
                  profile.user_base.home_Address_cn = content.home_Address_cn;
                } else {
                  profile.user_base.home_Address_cn = "";
                }
                if (content.home_Address_en) {
                  profile.user_base.home_Address_en = content.home_Address_en;
                } else {
                  profile.user_base.home_Address_en = "";
                }
                if (content.live_time) {
                  profile.user_base.live_time = content.live_time;
                } else {
                  profile.user_base.live_time = "";
                }
              } else {
                profile.user_base.user_information_id = item.id;
              }
            }
            if (item.class === "user_evaluate") {
              if (content) {
                content.user_information_id = item.id;
                profile.user_evaluate = content;
              } else {
                profile.user_evaluate.user_information_id = item.id;
              }
            }
            // if (item.class === "visa") {
            //   if (content) {
            //     content.user_information_id = item.id;
            //     profile.visa = content;
            //   } else {
            //     profile.visa.user_information_id = item.id;
            //   }
            // }
            if (
              item.class !== "user_base" ||
              item.class !== "user_evaluate" ||
              item.class !== "language_achievement_and_account_secrecy"
            ) {
              content.user_information_id = item.id;
            }
            if (item.class === "language_achievement_and_account_secrecy") {
              profile.language_achievement_and_account_secrecy.content =
                content.content;
              profile.language_achievement_and_account_secrecy.is_qualified =
                content.is_qualified;
              profile.language_achievement_and_account_secrecy.user_information_id =
                content.user_information_id;
            }
            if (item.class === "emergency_contact") {
              let l = []
              content.content.forEach((item, index) => {
                if (item.relation == '父亲') {
                  item.relation = '父亲(生父)'
                }
                if (item.relation == '母亲') {
                  item.relation = '母亲(生母)'
                }
                l.push(item)
              })
              profile.emergency_contact.content = content.content
              profile.emergency_contact.user_information_id = content.user_information_id
            }
            if (item.class === "educational_background") {
              if (!content.all_gpa) {
                content.all_gpa = ''
              }
              profile.educational_background.push(content);
            }
            if (item.class === "exchange_experiences") {
              profile.exchange_experiences.push(content);
            }
            if (item.class === "academic_projects") {
              profile.academic_projects.push(content);
            }
            if (item.class === "work_experience") {
              profile.work_experience.push(content);
            }
            if (item.class === "honorary_rewards") {
              profile.honorary_rewards.push(content);
            }
            if (item.class === "thesis") {
              profile.thesis.push(content);
            }
            if (item.class === "extracurricular_activities") {
              profile.extracurricular_activities.push(content);
            }
          });
          this.birthplace_arr = home;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    delLanguageAchievementAndAccountSecrecyList(index) {
      const next = () => {
        this.profile.language_achievement_and_account_secrecy.content.splice(
          index,
          1
        );
      };
      this.checkMaterialsUploaded(
        this.profile.language_achievement_and_account_secrecy.content[index]
          .user_information_id,
        next,
        "language_achievement_and_account_secrecy"
      );
    },
    delEducationalBackground(index) {
      const next = () => {
        this.profile.educational_background.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.educational_background[index].user_information_id,
        next
      );
    },
    delExchangeExperiences(index) {
      const next = () => {
        this.profile.exchange_experiences.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.exchange_experiences[index].user_information_id,
        next
      );
    },
    delAcademicProjects(index) {
      const next = () => {
        this.profile.academic_projects.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.academic_projects[index].user_information_id,
        next
      );
    },
    delWorkExperience(index) {
      const next = () => {
        this.profile.work_experience.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.work_experience[index].user_information_id,
        next
      );
    },
    delHonoraryRewards(index) {
      const next = () => {
        this.profile.honorary_rewards.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.honorary_rewards[index].user_information_id,
        next
      );
    },
    delThesis(index) {
      const next = () => {
        this.profile.thesis.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.thesis[index].user_information_id,
        next
      );
    },
    delExtracurricularActivities(index) {
      const next = () => {
        this.profile.extracurricular_activities.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.extracurricular_activities[index].user_information_id,
        next
      );
    },
    addLanguageAchievementAndAccountSecrecyList() {
      this.profile.language_achievement_and_account_secrecy.content.push({
        user_information_id: "",
        type: "",
        fraction: "",
        is_qualified: ""
      });
    },
    addEducationalBackground() {
      this.profile.educational_background.push({
        user_information_id: null,
        reading_status: "",
        stage: "",
        school: "",
        school_ename: "",
        major: "",
        major_ename: "",
        degree_type: "",
        time: [],
        ranking: "",
        gpa: "",
        sharing: "",
        is_change_major: "",
        core_curriculum: "",
        remarks: ''
      });
    },
    addExchangeExperiences() {
      this.profile.exchange_experiences.push({
        user_information_id: null,
        type: "",
        school: "",
        school_en: "",
        major: "",
        major_en: "",
        degree_type: "",
        time: [],
        gpa: "",
        sharing: "",
      });
    },
    addAcademicProjects(index) {
      this.profile.academic_projects.push({
        user_information_id: null,
        type: "",
        name: "",
        time: [],
        introduction: "",
        responsibility: "",
        methodology: "",
        outcome: "",
      });
    },
    addWorkExperience(index) {
      this.profile.work_experience.push({
        user_information_id: null,
        corporation_name: "",
        type: "",
        corporation_address: "",
        time: [],
        position: "",
        responsibility: "",
      });
    },
    addHonoraryRewards() {
      this.profile.honorary_rewards.push({
        user_information_id: null,
        date: "",
        type: "",
        name: "",
        content: "",
      });
    },
    addThesis() {
      this.profile.thesis.push({
        user_information_id: null,
        name: "",
        type: "",
        time: [],
        number: "",
      });
    },
    addExtracurricularActivities() {
      this.profile.extracurricular_activities.push({
        user_information_id: null,
        time: [],
        content: "",
        certificate: "",
      });
    },
    handleClose(tag) {
      this.profile.user_evaluate.dynamicTags.splice(
        this.profile.user_evaluate.dynamicTags.indexOf(tag),
        1
      );
    },
    getBirthplace(value) {
      this.profile.user_base.birthplace = value;
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.profile.user_evaluate.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
  computed: {
    eduDesc: {
      get() {
        let data = this.$store.state.userAbroad.userAbroadData;
        if (
          data &&
          data.apply_academic_degree &&
          (data.apply_academic_degree.includes("硕士学位") ||
            data.apply_academic_degree.includes("博士学位"))
        ) {
          return "请添加专科及其以上的教育经历，并且包含目前在读";
        } else {
          return "请添加高中及其以上的教育经历，并且包含目前在读";
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.clear {
  clear: both;
}

.dynamicTags {
  margin-bottom: 1rem;
  border-bottom: 1px solid #dcdcdc;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .my_content {
    flex: 1;
  }
  .icon {
    width: 50px;
    text-align: center;
    font-weight: 900;
    font-size: 25px;
  }
}

.hb-user-profile-edit-page {
  .el-form-item {
    margin-bottom: 0 !important;
  }
  .submit-wrapper {
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .require-flag {
    font-size: 20px !important;
    font-weight: 550 !important;
    color: red !important;
  }
  .box-card {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_three.vue